import type { NftRarity } from "@anaconda/core/nft/types"
import { cn, cva } from "@rarible_int/anaconda_ui_components"

interface RarityProps {
  rarity: NftRarity
  className?: string
  size?: "sm" | "lg"
}

const rarityVariants = cva("bg-foreground text-foregroundInvert", {
  variants: {
    size: {
      sm: "rounded-xs py-[1px] px-1 text-xs",
      lg: "rounded-sm py-[2px] px-[6px] text-lg",
    },
  },
})

const colorTiers = [
  { max: 0.1, color: "#FF8A15" },
  { max: 1, color: "#BE95FF" },
  { max: 10, color: "#77A9FF" },
  { max: 50, color: "#04CD58" },
  { max: 100, color: "#ADADB2" },
]

function getRarityColor(rarity: NftRarity) {
  if (rarity.rank === 1) {
    return "#D6A800"
  }

  return (
    colorTiers.find((tier) => rarity.percentile <= tier.max)?.color ??
    colorTiers[colorTiers.length - 1].color
  )
}

export default function Rarity({
  rarity,
  className,
  size = "sm",
}: RarityProps) {
  const rarityColor = getRarityColor(rarity)
  const formattedRank = rarity.rank.toLocaleString()

  return (
    <span
      className={cn(rarityVariants({ size }), className)}
      style={{ color: rarityColor, backgroundColor: `${rarityColor}1A` }}
    >
      {formattedRank}
    </span>
  )
}
